import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { useDialer } from "./hooks/useDialer";
import AppLayout from "./components/layout/AppLayout";
import SignIn from "./pages/SignIn";
import SignUp from "./pages/SignUp";
import Setup from "./pages/Setup";
import Phone from "./pages/Phone";
import Contacts from "./pages/Contacts";
import Leads from "./pages/Leads";
import History from "./pages/History";
import Dashboard from "./pages/Dashboard";
import Queue from "./pages/Queue";
import Settings from "./pages/Settings";

const AdminRoute = ({ children }) => {
  const stored = JSON.parse(localStorage.getItem("lv_user") || "{}");
  if (stored?.role !== "admin") return <Navigate to="/app/phone" replace />;
  return children;
};
import "./index.css";

function AppWithDialer() {
  const dialerState = useDialer();
  window.__ds = dialerState;
  return (
    <Routes>
      <Route path="/app" element={<AppLayout dialerState={dialerState} />}>
        <Route path="phone"     element={<Phone />} />
        <Route path="contacts"  element={<Contacts isLead={false} />} />
        <Route path="leads"     element={<Leads />} />
        <Route path="history"   element={<History />} />
        <Route path="dashboard" element={<Dashboard />} />
        <Route path="queue"     element={<Queue />} />
        <Route path="settings"  element={<AdminRoute><Settings /></AdminRoute>} />
        <Route index            element={<Navigate to="/app/phone" replace />} />
      </Route>
      <Route path="*" element={<Navigate to="/app/phone" replace />} />
    </Routes>
  );
}

function AppRoutes() {
  const { user, loading, isConfigured } = useAuth();
  if (loading) return <div style={{height:"100vh",background:"#161616"}} />;
  if (!user) return (
    <Routes>
      <Route path="/signin" element={<SignIn />} />
      <Route path="/signup" element={<SignUp />} />
      <Route path="*" element={<Navigate to="/signin" replace />} />
    </Routes>
  );
  if (!isConfigured) return (
    <Routes>
      <Route path="/setup" element={<Setup />} />
      <Route path="*" element={<Navigate to="/setup" replace />} />
    </Routes>
  );
  return <AppWithDialer />;
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
